<nz-spin [nzSpinning]="loading">
    @if (invoiceData) {
        <h3>Virsrēķina dati</h3>
        <div nz-row nzGutter="8">
            <div nz-col nzSpan="8" [nzLg]="8" [nzMd]="12" [nzSm]="24" [nzXs]="24" class="mb-3">
                <p class="m-0"><strong>Numurs: </strong>{{ invoiceData.number }}</p>
                @if (invoiceData.invoiceType) {
                    <p class="m-0"><strong>Rēķina tips: </strong>{{ invoiceData.invoiceType.name }}</p>
                }
                @if (invoiceData.invoiceOrders?.length > 0) {
                    <p class="m-0">
                        <strong>{{ invoiceData.invoiceOrders.length > 1 ? 'Pasūtījumi' : 'Pasūtījums' }}: </strong
                        >{{ invoiceOrdersToString(invoiceData.invoiceOrders) }}
                    </p>
                }
                <p class="m-0"><strong>Datums: </strong>{{ invoiceData.date | date: DATE_FORMAT }}</p>
                <p class="m-0"><strong>Samaksāt līdz: </strong>{{ invoiceData.dateUntil | date: DATE_FORMAT }}</p>
                @if (invoiceData.serviceDate) {
                    <p class="m-0"><strong>Pakalpojuma sniegšanas datums: </strong>{{ invoiceData.serviceDate | date: DATE_FORMAT }}</p>
                }
                @if (invoiceData.department) {
                    <p class="m-0"><strong>Departaments: </strong>{{ departmentToString(invoiceData.department) }}</p>
                }
                @if (invoiceData.client) {
                    <p class="m-0"><strong>Klients: </strong><cl-client-name [client]="invoiceData.client"></cl-client-name></p>
                }
                @if (invoiceData.notes) {
                    <p class="m-0"><strong>Piezīmes: </strong>{{ invoiceData.notes }}</p>
                }
                @if (invoiceData.lastNotificationTimestamp) {
                    <p class="m-0">
                        <strong>Pēdējais paziņojums klientam nosūtīts: </strong>{{ invoiceData.lastNotificationTimestamp | date: DATE_TIME_FORMAT }}
                    </p>
                }
                <div class="mt-2">
                    <h3>Summas</h3>
                    <p class="m-0"><strong>Bez PVN: </strong>{{ invoiceData.sumWithoutVat | eur }}</p>
                    <p class="m-0">
                        <strong>PVN ({{ invoiceData.vatPercent ?? 0 }}%): </strong>{{ invoiceData.sumVat | eur }}
                    </p>
                    @if (invoiceData.penaltySumWithoutVat) {
                        <p class="m-0"><strong>Ar PVN: </strong>{{ invoiceData.sumWithoutVat + invoiceData.sumVat | eur }}</p>
                    }
                    @if (invoiceData.penaltySumWithoutVat) {
                        <p class="m-0"><strong>Līgumsods: </strong>{{ invoiceData.penaltySumWithoutVat | eur }}</p>
                    }
                    <p class="m-0"><strong>Kopā: </strong>{{ invoiceData.sumWithVat | eur }}</p>
                    @if (!invoiceData.isPaid) {
                        <p class="m-0">
                            <strong>Neapmaksāts: </strong><span class="text-danger fw-500">{{ invoiceData.unpaidSum | eur }}</span>
                        </p>
                    }
                </div>
                <div nz-row nzGutter="8" class="mt-3">
                    <cl-info-button
                        [id]="invoiceData.id"
                        class="mr-1"
                        [entityType]="EntityType.Sinvoice"
                        (loadingChanged)="loading = $event"
                    ></cl-info-button>
                    <cl-notification-history-button
                        [entityType]="EntityType.Sinvoice"
                        [id]="invoiceData.id"
                        class="ml-2 mr-3"
                    ></cl-notification-history-button>
                    @if (invoiceData.invoices.length > 0) {
                        <button
                            *hasPermission="[GroupPermission.INVOICE_VIEW]"
                            nz-button
                            nz-tooltip
                            nzTooltipTitle="Lejupielādēt izdruku"
                            nzType="info"
                            class="mr-2"
                            (click)="downloadInvoicePrintout()"
                        >
                            <i nz-icon nzType="file-pdf"></i>
                        </button>
                        <cl-file-preview [fileName]="invoiceData.number + '.pdf'" [loadFileMetadata]="invoicePreviewMetadata" [downloadFile]="invoicePreviewDownload"></cl-file-preview>

                        <button
                            nz-button
                            nz-tooltip
                            nzTooltipTitle="Lejupielādēt e-rēķinu"
                            nzType="info"
                            class="ant-btn-icon-only mr-3"
                            (click)="downloadInvoiceEInvoiceXML()"
                        >
                            <fa-icon [icon]="xmlIcon"></fa-icon>
                        </button>
                    }
                    <button
                        *hasPermission="[GroupPermission.INVOICE_VIEW]"
                        nz-button
                        nz-tooltip
                        nzTooltipTitle="Skatīt LUIDAIS"
                        nzType="info"
                        class="mr-2"
                        (click)="gotoLuidaisInvoice()"
                    >
                        <span nz-icon nzType="link" nzTheme="outline"></span>
                    </button>
                    @if (!invoiceData.isPaid && !invoiceData.isDeleted && invoiceData.invoices.length > 0) {
                        <button
                            *hasPermission="[GroupPermission.INVOICE_VIEW]"
                            nz-button
                            nz-tooltip
                            nzTooltipTitle="Nosūtīt atgādinājumu"
                            nzType="info"
                            class="mr-2"
                            (click)="sendInvoiceNotification()"
                        >
                            <span nz-icon nzType="send" nzTheme="outline"></span>
                        </button>
                        <button
                            *hasPermission="[GroupPermission.SINVOICE_EDIT]"
                            nz-button
                            nz-tooltip
                            nzTooltipTitle="Nosūtīt atgādinājumu darbiniekam"
                            nzType="info"
                            (click)="sendEmployeeInvoiceNotification()"
                        >
                            <span nz-icon nzType="mail" nzTheme="outline"></span>
                        </button>
                    }
                    <button nz-button class="mr-2 ml-2" nzType="info" (click)="back()">Atpakaļ</button>
                    @if (invoiceData.department) {
                        <ng-container
                            *hasDepartmentPermission="{ departmentId: invoiceData.department.id, permissions: [DepartmentPermissions.EDIT] }"
                        >
                            <button *hasPermission="[GroupPermission.SINVOICE_EDIT]" nz-button nzType="primary" (click)="edit()">Labot</button>
                        </ng-container>
                    } @else {
                        <button *hasPermission="[GroupPermission.SINVOICE_EDIT]" nz-button nzType="primary" (click)="edit()">Labot</button>
                    }
                </div>
            </div>
            <div nz-col nzSpan="16" [nzLg]="16" [nzMd]="24" [nzSm]="24" [nzXs]="24">
                <div>
                    <h3>Maksājumi</h3>
                    <div class="w-full table-container">
                        @if (invoiceData.payments?.length > 0) {
                            <nz-table
                                #payments
                                [nzData]="invoiceData.payments"
                                nzSize="small"
                                [nzFrontPagination]="false"
                                [nzScroll]="{ y: '15rem', x: '50rem' }"
                            >
                                <thead>
                                    <tr>
                                        <th [nzSortFn]="sortByPaymentTypeName">Maksājuma tips</th>
                                        <th [nzSortFn]="sortByPaymentBankReference">Maksājuma reference</th>
                                        <th [nzSortFn]="sortByPaymentDate">Datums</th>
                                        <th [nzSortFn]="sortByPaymentSumWithVat">Summa</th>
                                        <th [nzSortFn]="sortByPaymentAccepted">Apstiprināts</th>
                                        <th [nzSortFn]="sortByPaymentStatusName">Statuss</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (payment of payments.data; track payment.id) {
                                        <tr>
                                            <td>{{ payment.paymentTypeName ? payment.paymentTypeName : '-' }}</td>
                                            <td>{{ payment.bankReference ? payment.bankReference : '-' }}</td>
                                            <td>{{ payment.date ? (payment.date | date: DATE_FORMAT) : '-' }}</td>
                                            <td>{{ payment.sumWithVat ? (payment.sumWithVat | eur) : '-' }}</td>
                                            <td><cl-true-false-table-icon [value]="payment.accepted"></cl-true-false-table-icon></td>
                                            <td>{{ payment.statusName ? payment.statusName : '-' }}</td>
                                        </tr>
                                    }
                                </tbody>
                            </nz-table>
                        } @else {
                            <p class="m-0">Neviens maksājums nav veikts</p>
                        }
                    </div>
                </div>
                <div class="mt-3">
                    <h3>Rēķini</h3>
                    <div class="w-full table-container">
                        @if (invoiceData.invoices?.length > 0) {
                            <nz-table
                                #sinvoiceInvoices
                                [nzData]="invoiceData.invoices"
                                nzSize="small"
                                [nzFrontPagination]="false"
                                [nzScroll]="{ y: '15rem', x: '50rem' }"
                            >
                                <thead>
                                    <tr>
                                        <th [nzSortFn]="sortByInvoiceNumber">Numurs</th>
                                        <th [nzSortFn]="sortByInvoiceDate">Datums</th>
                                        <th [nzSortFn]="sortByInvoiceUntilDate">Apmaksas termiņš</th>
                                        <th [nzSortFn]="sortByInvoiceSumWithVat">Summa (ar PVN)</th>
                                        <th [nzSortFn]="sortByInvoiceIsPaid">Apmaksāts</th>
                                        <th [nzSortFn]="sortByInvoiceUnpaidSum">Neapmaksātā summa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (invoice of sinvoiceInvoices.data; track invoice.id) {
                                        <tr>
                                            <td>{{ invoice.number ? invoice.number : '-' }}</td>
                                            <td>{{ invoice.date ? (invoice.date | date: DATE_FORMAT) : '-' }}</td>
                                            <td>{{ invoice.untilDate ? (invoice.untilDate | date: DATE_FORMAT) : '-' }}</td>
                                            <td>{{ invoice.sumWithVat | eur }}</td>
                                            <td><cl-true-false-table-icon [value]="invoice.isPaid"></cl-true-false-table-icon></td>
                                            <td>{{ invoice.unpaidSum | eur }}</td>
                                        </tr>
                                    }
                                </tbody>
                            </nz-table>
                        } @else {
                            <p class="m-0">Neviens apakšrēķins nav atrasts</p>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
</nz-spin>
